import React, { useEffect, useRef, useState } from "react";
import { SEO } from "../../components/common/SEO";
import Hero from "../../components/common/Hero";
import TabbedCategoryMenu from "../../components/common/TabbedCategoryMenu";
import HomeToysDisplay from "../../components/common/HomeToysDisplay";
import { deleteSession, getSession } from "../../utils";
import SnackbarAlert, {
  SnackbarRef,
} from "../../components/common/SnackbarAlert";
import { USER_JUST_LOGGED_OUT } from "../../constants";
import { SnackbarNotify } from "../../components/common/SnackbarNotify";

const Home: React.FC = () => {
  const [categorySelected, setCategorySelected] = useState("latest-toys");

  return (
    <>
      <SEO
        title="Buy and Sell Toys Online • FiddlePiddle • Toys Marketplace"
        description="Millions of users buy and sell their old or new toys on our platform Fiddlepiddle - A Global Online Toy Marketplace. No Listing Fees, Instant Pay and Easy to Use."
        keywordsContent="toys, sell old toys, how to sell old toys, sell old toys online, sell new toys, new toys online, toys marketplace, marketplace for toys, toys platform for selling, buying toys, old toys, new toys, collectors toys, where to sell old toys near me, fiddle piddle, smart glasses, spy gadgets, toddlers toys, education toys, sell old toys, where to sell toys online, where to sell toys near me, selling toys online, buying toys online, toys marketplace platform, marketplace toys, sell toys near me, sell used toys online, fisher price, marvel toys, action figures, how to sell toys online, rideamals scout, usb audio recorder, sell old toys for cash near me, buy old toys online, fiddlepiddle review, where can i sell my old toys, best place to sell toys, omg, disney descendants, what do you meme, barbie, mattel, sell kids toys online, trump lego figure, sell used toys for cash near me, battling toys, ps4 controller, marvel legends, lego harry potter, paw patrol, suge knight action figure, mega bloks, best way to sell toys online, market place toys, sell toys for cash, sell toys for cash near me, prism kite, best website to sell toys, step2, sell your toys near me, uno, bratz, for the gurls adult party game, indoor wooden playground, psp 1000 shell replacement, infant toys, electronic toys, game systems, video games, portable, Dolls, Collectible Trading Cards and Toys, Games & Puzzles, Plush, Ride Ons, Youth Electronics, Collectible Trading Toys and Accessories, ebay, amazon toys, top 100 toys, christmas toys, birthday toys, toys for boys, toys for girls, kids toys, toys for teens"
      />
      <Hero />
      <TabbedCategoryMenu
        setCategorySelected={setCategorySelected}
        categorySelected={categorySelected}
      />
      <HomeToysDisplay categorySelected={categorySelected} />
      <SnackbarNotify
        message="Signed out successfully"
        sessionKey={USER_JUST_LOGGED_OUT}
      />
    </>
  );
};

export default Home;
